import { type SpaceLegacyKeys, spaceLegacy } from "./legacy/token-space";

export const spaceTokens = {
  sp0: 0,
  "sp0.5": 4,
  sp1: 8,
  "sp1.5": 12,
  sp2: 16,
  "sp2.5": 20,
  sp3: 24,
  sp4: 32,
  sp5: 40,
  sp6: 48,
  sp7: 56,
  sp8: 64,
  sp9: 72,
  sp10: 80,
} as const;

export type SpaceTokensKeys = keyof typeof spaceTokens;

export const space: typeof spaceTokens & typeof spaceLegacy = {
  ...spaceLegacy,
  ...spaceTokens,
};

export type SpaceKeys = SpaceTokensKeys | SpaceLegacyKeys;
